var React = require('react');

function Section2MiddleLeftInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(-5 -9)"},[React.createElement("ellipse",{"cx":"48.054","cy":"254.845","fill":"#FEFCBE","rx":"28.054","ry":"27.845","key":0}),React.createElement("polygon",{"fill":"#FFCCF3","points":"14.96 245.781 5 208.886 42.172 199 52.133 235.895","key":1}),React.createElement("polygon",{"fill":"#E7F5FF","points":"73.054 81.839 21.446 21.222 70.541 2.516","transform":"rotate(60 47.25 42.178)","key":2}),React.createElement("circle",{"cx":"86.751","cy":"41.751","r":"14.5","fill":"#F58C8C","transform":"rotate(-1 86.75 41.75)","key":3})]));
}

Section2MiddleLeftInline.defaultProps = {"width":"97","height":"274","viewBox":"0 0 97 274"};

module.exports = Section2MiddleLeftInline;

Section2MiddleLeftInline.default = Section2MiddleLeftInline;
